import { AxiosResponse } from "axios";
import { showConsoleError } from "../util/ConsoleMessage";
import { EditablePair, Language, SimilarKnowledgeResponse } from "./responsePayload/KnowledgeResponse";
import { createPayload, apiPatchRequest, apiPostRequest, apiDeleteRequest } from "./util/apiUtils";
import { Endpoint } from "./util/contants";


export const KowledgeContentStatusPatch = async (
  id: number,
  updatedQuestion: string = "",
  updatedAnswer: string = "",
  updatedContent: string = ""
): Promise<AxiosResponse | null> => {
  const basePayload = {
    ...(updatedQuestion && { question: updatedQuestion }),
    ...(updatedAnswer && { answer: updatedAnswer }),
    ...(updatedContent && { content: updatedContent }),
  };
  const payload = createPayload(basePayload);
  return await apiPatchRequest(Endpoint.KnowledgeContent, { id: id }, payload);
};

export const KowledgeContentImagePatch = async (
  id: number,
  imageIds: number[]
): Promise<AxiosResponse | null> => {
  const basePayload = {
    knowledge_content_images: [...imageIds],
  };
  const payload = createPayload(basePayload);
  return await apiPatchRequest(Endpoint.KnowledgeContent, { id: id }, payload);
};


export const KowledgeContentBulkUpdateStatus = async (
  ids: number[],
  status: number
): Promise<AxiosResponse | null> => {
  const basePayload = {
    knowledge_content_ids: ids,
    new_status: status,
  };

  const payload = createPayload(basePayload);
  try {
    const res: AxiosResponse | null = await apiPostRequest(
      Endpoint.KnowledgeContentBulkUpdateStatus,
      payload
    );

    if (status == 3) {
      await UpdateBrainKnowledge(ids);
    }
    return res;
  } catch (error) {
    showConsoleError("Error during bulk update:", error);

    return null;
  }
};

export const KowledgeContentUpdateReject = async (
  ids: number,
  status: number,
  errorCode: number,
  message?: string
): Promise<AxiosResponse | null> => {
  const basePayload = {
    knowledge_content: ids,
    new_status: status,
    error_code: errorCode,
    ...(message && { reason: message }),
  };

  const payload = createPayload(basePayload);
  try {
    const res: AxiosResponse | null = await apiPostRequest(
      Endpoint.knowledgeContentUpdateReject,
      payload
    );

    if (status == 3) {
      await UpdateBrainKnowledge([ids]);
    }
    return res;
  } catch (error) {
    showConsoleError("Error during bulk update:", error);

    return null;
  }
};

export const KowledgeContentBulkCreate = async (data: {
  [key: number]: EditablePair[];
}): Promise<AxiosResponse | null> => {
  const result = Object.entries(data).flatMap(([contextId, items]) =>
    items
      .filter((item) => item.selected)
      .map((item) => ({
        context: Number(contextId),
        category: item.category_id,
        subcategory: item.subcategory_id,
        type: 1,
        question: item.question,
        answer: item.answer,
        content: "",
      }))
  );
  const basePayload = {
    knowledge_content_list: result,
  };

  const payload = createPayload(basePayload);
  try {
    const res: AxiosResponse | null = await apiPostRequest(
      Endpoint.KowledgeContentBulkCreate,
      payload
    );

    return res;
  } catch (error) {
    showConsoleError("Error during bulk update:", error);

    return null;
  }
};

export const UpdateBrainKnowledge = async (
  ids: number[]
): Promise<AxiosResponse | null> => {
  const basePayload = {
    knowledge_content_ids: ids,
  };

  const payload = createPayload(basePayload);
  return await apiPostRequest(Endpoint.BrainKnowledgeBulkUpdate, payload);
};

export const KowledgeContentDelete = async (
  id: number
): Promise<AxiosResponse | null> => {
  return await apiDeleteRequest(Endpoint.KnowledgeContent, { id: id });
};

export const KowledgeContentBulkDelete = async (
  ids: number[]
): Promise<AxiosResponse | null> => {
  const basePayload = {
    ids: ids,
  };

  const payload = createPayload(basePayload);
  return await apiPostRequest(Endpoint.KnowledgeContentBulkDelete, payload);
};

export const CreateKnowledge = async (
  categoryId: number,
  subCategoryId: number,
  question: string,
  answer: string
): Promise<AxiosResponse | null> => {
  const basePayload = {
    category: categoryId,
    subcategory: subCategoryId,
    question: question,
    answer: answer,
    language: Language.MALAYSIAN.id,
  };

  const payload = createPayload(basePayload);
  return await apiPostRequest(Endpoint.CreateKnowledge, payload);
};


export const KnowledgeContentCheckSimilarKnowledge = async (
  question: string,
  answer: string,
  type: number = 1, // only type 1 (FAQ) is supported for now!!
  top_n?: string,
  rerank_top_n?: string
): Promise<SimilarKnowledgeResponse | null> => {
  const basePayload = {
    type: type,
    question: question,
    answer: answer,
    top_n: top_n,
    rerank_top_n: rerank_top_n,
  };

  const payload = createPayload(basePayload);
  return await apiPostRequest(
    Endpoint.KnowledgeContentCheckSimilarKnowledge,
    payload
  );
};

